import DataTable, { TableProps, createTheme } from "react-data-table-component";
import { HiChevronDown } from "react-icons/hi";
import "./styles.css";
import { useState } from "react";

const sortIcon = <HiChevronDown />;
// const selectProps = {
//   indeterminate: (isIndeterminate: boolean) => isIndeterminate,
// };
createTheme(
  "gabit",
  {
    text: {
      primary: "#000",
      secondary: "#2d2d2d",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "light"
);

const paginationComponentOptions = {
  selectAllRowsItem: true,
  selectAllRowsItemText: "ALL",
};

function DataTableBase<T>(props: TableProps<T>): JSX.Element {
  return (
    <DataTable
      sortIcon={sortIcon}
      theme="gabit"
      customStyles={tableCustomStyles}
      pagination
      paginationComponentOptions={paginationComponentOptions}
      {...props}
    />
  );
}

const tableCustomStyles = {
  headCells: {
    style: {
      backgroundColor: "lightgray",
      padding: "10px",
    },
  },
};
export default DataTableBase;
